import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LANGS = [
  { code: "en", name: "English", flag: "EN" },
  { code: "de", name: "Deutsch", flag: "DE" },
  { code: "fr", name: "Français", flag: "FR" },
  { code: "it", name: "Italiano", flag: "IT" },
  { code: "ru", name: "Русский", flag: "RU" },
  { code: "ar", name: "العربية", flag: "AR" },
  { code: "zh", name: "中文", flag: "ZH" },
  { code: "ja", name: "日本語", flag: "JA" },
  { code: "da", name: "Dansk", flag: "DA" },
];

export const STATIC_T = {
  en: {
    nav_home: "Home", nav_history: "History", nav_sights: "Sights", nav_beaches: "Beaches & Diving",
    nav_mountains: "Mountains & Desert", nav_directory: "Directory", nav_tips: "Travel Tips",
    nav_gallery: "Gallery", nav_map: "Map", nav_advertise: "Advertise", nav_admin: "Admin",
    hero_eyebrow: "Red Sea · Egypt",
    hero_title: "Al Quseir",
    hero_subtitle: "An ancient port. A timeless coast. A living mosaic of cultures, currents and centuries on the Egyptian Red Sea.",
    hero_cta_primary: "Explore the Town", hero_cta_secondary: "Find a Hotel",
    section_history: "History", section_sights: "Sights", section_beaches: "Beaches",
    section_diving: "Diving", section_mountains: "Mountains & Desert", section_culture: "Culture", section_tips: "Travel Tips",
    dive_sites_title: "Iconic Dive Sites",
    home_eyebrow_welcome: "01 — Welcome",
    home_eyebrow_discover: "02 — Discover",
    home_intro_heading: "Where the desert meets the reef.",
    home_discover_heading: "Four ways to fall in love with Al Quseir.",
    home_history_blurb: "From Pharaonic Punt expeditions to the Ottoman fortress of 1571.",
    home_beaches_blurb: "Quiet bays, golden sand, transparent water.",
    home_diving_blurb: "Untouched reefs, dolphins of Sataya, Elphinstone drop-offs.",
    home_sights_blurb: "Coral-stone houses, fortress walls, sunset on the harbor.",
    home_for_business: "For local businesses",
    directory_title: "Where to Stay, Eat & Explore",
    directory_subtitle: "Hand-picked hotels, restaurants, dive centers and shops in Al Quseir.",
    tab_all: "All", tab_hotel: "Hotels", tab_restaurant: "Restaurants", tab_diving: "Diving", tab_shop: "Shops", tab_activity: "Activities",
    featured: "Featured", sponsored: "Sponsored",
    advertise_title: "Promote Your Business",
    advertise_subtitle: "Reach travellers from across the world. List your hotel, restaurant or shop on Al Quseir's tourism portal.",
    form_name: "Your Name", form_email: "Email", form_business: "Business Name",
    form_business_type: "Business Type", form_message: "Message", form_submit: "Send Inquiry",
    form_success: "Thank you, we will contact you soon.",
    map_title: "Find Al Quseir",
    footer_about: "Al Quseir is a historic Red Sea port city in Egypt's Eastern Desert.",
    footer_rights: "All rights reserved.",
    admin_login_title: "Admin Sign-in",
    admin_email: "Email", admin_password: "Password", admin_signin: "Sign in",
    admin_dashboard: "Admin Dashboard", admin_logout: "Logout",
    admin_businesses: "Businesses", admin_inquiries: "Inquiries", admin_content: "Content",
    no_content_yet: "Content is being prepared. Please come back in a moment.",
    read_more: "Read more",
  },
  de: {
    nav_home: "Start", nav_history: "Geschichte", nav_sights: "Sehenswürdigkeiten", nav_beaches: "Strände & Tauchen",
    nav_mountains: "Berge & Wüste", nav_directory: "Verzeichnis", nav_tips: "Reisetipps",
    nav_gallery: "Galerie", nav_map: "Karte", nav_advertise: "Werbung", nav_admin: "Admin",
    hero_eyebrow: "Rotes Meer · Ägypten",
    hero_title: "Al Quseir",
    hero_subtitle: "Ein antiker Hafen. Eine zeitlose Küste. Ein lebendiges Mosaik aus Kulturen, Strömungen und Jahrhunderten am ägyptischen Roten Meer.",
    hero_cta_primary: "Stadt entdecken", hero_cta_secondary: "Hotel finden",
    section_history: "Geschichte", section_sights: "Sehenswürdigkeiten", section_beaches: "Strände",
    section_diving: "Tauchen", section_mountains: "Berge & Wüste", section_culture: "Kultur", section_tips: "Reisetipps",
    dive_sites_title: "Legendäre Tauchplätze",
    home_eyebrow_welcome: "01 — Willkommen",
    home_eyebrow_discover: "02 — Entdecken",
    home_intro_heading: "Wo die Wüste auf das Riff trifft.",
    home_discover_heading: "Vier Arten, sich in Al Quseir zu verlieben.",
    home_history_blurb: "Von den pharaonischen Punt-Expeditionen bis zur osmanischen Festung von 1571.",
    home_beaches_blurb: "Stille Buchten, goldener Sand, glasklares Wasser.",
    home_diving_blurb: "Unberührte Riffe, Delfine von Sataya, Elphinstone-Steilwände.",
    home_sights_blurb: "Korallenstein-Häuser, Festungsmauern, Sonnenuntergang am Hafen.",
    home_for_business: "Für lokale Unternehmen",
    directory_title: "Übernachten, Essen & Erleben",
    directory_subtitle: "Handverlesene Hotels, Restaurants, Tauchbasen und Geschäfte in Al Quseir.",
    tab_all: "Alle", tab_hotel: "Hotels", tab_restaurant: "Restaurants", tab_diving: "Tauchen", tab_shop: "Shops", tab_activity: "Aktivitäten",
    featured: "Empfohlen", sponsored: "Anzeige",
    advertise_title: "Bewerben Sie Ihr Geschäft",
    advertise_subtitle: "Erreichen Sie Reisende aus aller Welt. Listen Sie Ihr Hotel, Restaurant oder Geschäft auf Al Quseirs Tourismus-Portal.",
    form_name: "Ihr Name", form_email: "E-Mail", form_business: "Geschäftsname",
    form_business_type: "Art des Geschäfts", form_message: "Nachricht", form_submit: "Anfrage senden",
    form_success: "Vielen Dank, wir melden uns in Kürze.",
    map_title: "Al Quseir finden",
    footer_about: "Al Quseir ist eine historische Hafenstadt am Roten Meer in der östlichen Wüste Ägyptens.",
    footer_rights: "Alle Rechte vorbehalten.",
    admin_login_title: "Admin-Anmeldung",
    admin_email: "E-Mail", admin_password: "Passwort", admin_signin: "Anmelden",
    admin_dashboard: "Admin-Dashboard", admin_logout: "Abmelden",
    admin_businesses: "Unternehmen", admin_inquiries: "Anfragen", admin_content: "Inhalte",
    no_content_yet: "Inhalte werden gerade vorbereitet. Bitte schauen Sie gleich wieder vorbei.",
    read_more: "Mehr lesen",
  },
  fr: {
    nav_home: "Accueil", nav_history: "Histoire", nav_sights: "Sites", nav_beaches: "Plages & Plongée",
    nav_mountains: "Montagnes & Désert", nav_directory: "Annuaire", nav_tips: "Conseils",
    nav_gallery: "Galerie", nav_map: "Carte", nav_advertise: "Publicité", nav_admin: "Admin",
    hero_eyebrow: "Mer Rouge · Égypte",
    hero_title: "Al Quseir",
    hero_subtitle: "Un port antique. Une côte intemporelle. Une mosaïque vivante de cultures, de courants et de siècles sur la mer Rouge égyptienne.",
    hero_cta_primary: "Découvrir la ville", hero_cta_secondary: "Trouver un hôtel",
    section_history: "Histoire", section_sights: "Sites", section_beaches: "Plages",
    section_diving: "Plongée", section_mountains: "Montagnes & Désert", section_culture: "Culture", section_tips: "Conseils",
    dive_sites_title: "Sites de plongée emblématiques",
    home_eyebrow_welcome: "01 — Bienvenue",
    home_eyebrow_discover: "02 — Découvrir",
    home_intro_heading: "Là où le désert rencontre le récif.",
    home_discover_heading: "Quatre façons de tomber amoureux d'Al Quseir.",
    home_history_blurb: "Des expéditions pharaoniques de Pount à la forteresse ottomane de 1571.",
    home_beaches_blurb: "Baies calmes, sable doré, eau transparente.",
    home_diving_blurb: "Récifs intacts, dauphins de Sataya, tombants d'Elphinstone.",
    home_sights_blurb: "Maisons en pierre de corail, murailles, coucher de soleil sur le port.",
    home_for_business: "Pour les entreprises locales",
    directory_title: "Où dormir, manger & explorer",
    directory_subtitle: "Hôtels, restaurants, centres de plongée et boutiques sélectionnés à Al Quseir.",
    tab_all: "Tous", tab_hotel: "Hôtels", tab_restaurant: "Restaurants", tab_diving: "Plongée", tab_shop: "Boutiques", tab_activity: "Activités",
    featured: "Recommandé", sponsored: "Sponsorisé",
    advertise_title: "Promouvoir votre entreprise",
    advertise_subtitle: "Atteignez des voyageurs du monde entier. Référencez votre hôtel, restaurant ou boutique sur le portail touristique d'Al Quseir.",
    form_name: "Votre nom", form_email: "E-mail", form_business: "Nom de l'entreprise",
    form_business_type: "Type d'entreprise", form_message: "Message", form_submit: "Envoyer",
    form_success: "Merci, nous vous recontacterons bientôt.",
    map_title: "Localiser Al Quseir",
    footer_about: "Al Quseir est un port historique de la mer Rouge dans le désert oriental égyptien.",
    footer_rights: "Tous droits réservés.",
    admin_login_title: "Connexion Admin",
    admin_email: "E-mail", admin_password: "Mot de passe", admin_signin: "Connexion",
    admin_dashboard: "Tableau Admin", admin_logout: "Déconnexion",
    admin_businesses: "Entreprises", admin_inquiries: "Demandes", admin_content: "Contenu",
    no_content_yet: "Le contenu est en préparation. Revenez dans un instant.",
    read_more: "Lire la suite",
  },
  it: {
    nav_home: "Home", nav_history: "Storia", nav_sights: "Luoghi", nav_beaches: "Spiagge e Immersioni",
    nav_mountains: "Montagne e Deserto", nav_directory: "Elenco", nav_tips: "Consigli",
    nav_gallery: "Galleria", nav_map: "Mappa", nav_advertise: "Pubblicità", nav_admin: "Admin",
    hero_eyebrow: "Mar Rosso · Egitto",
    hero_title: "Al Quseir",
    hero_subtitle: "Un porto antico. Una costa senza tempo. Un mosaico vivente di culture, correnti e secoli sul Mar Rosso egiziano.",
    hero_cta_primary: "Esplora la città", hero_cta_secondary: "Trova un hotel",
    section_history: "Storia", section_sights: "Luoghi", section_beaches: "Spiagge",
    section_diving: "Immersioni", section_mountains: "Montagne e Deserto", section_culture: "Cultura", section_tips: "Consigli",
    dive_sites_title: "Siti di immersione iconici",
    home_eyebrow_welcome: "01 — Benvenuti",
    home_eyebrow_discover: "02 — Scopri",
    home_intro_heading: "Dove il deserto incontra la barriera corallina.",
    home_discover_heading: "Quattro modi per innamorarti di Al Quseir.",
    home_history_blurb: "Dalle spedizioni faraoniche a Punt alla fortezza ottomana del 1571.",
    home_beaches_blurb: "Baie tranquille, sabbia dorata, acqua trasparente.",
    home_diving_blurb: "Barriere coralline incontaminate, delfini di Sataya, scogliere di Elphinstone.",
    home_sights_blurb: "Case in pietra corallina, mura della fortezza, tramonto sul porto.",
    home_for_business: "Per le attività locali",
    directory_title: "Dove dormire, mangiare ed esplorare",
    directory_subtitle: "Hotel, ristoranti, diving center e negozi selezionati a Al Quseir.",
    tab_all: "Tutti", tab_hotel: "Hotel", tab_restaurant: "Ristoranti", tab_diving: "Diving", tab_shop: "Negozi", tab_activity: "Attività",
    featured: "In evidenza", sponsored: "Sponsorizzato",
    advertise_title: "Promuovi la tua attività",
    advertise_subtitle: "Raggiungi viaggiatori da tutto il mondo. Inserisci il tuo hotel, ristorante o negozio nel portale turistico di Al Quseir.",
    form_name: "Il tuo nome", form_email: "E-mail", form_business: "Nome attività",
    form_business_type: "Tipo di attività", form_message: "Messaggio", form_submit: "Invia richiesta",
    form_success: "Grazie, ti contatteremo presto.",
    map_title: "Trova Al Quseir",
    footer_about: "Al Quseir è una storica città portuale del Mar Rosso nel deserto orientale egiziano.",
    footer_rights: "Tutti i diritti riservati.",
    admin_login_title: "Accesso Admin",
    admin_email: "E-mail", admin_password: "Password", admin_signin: "Accedi",
    admin_dashboard: "Dashboard Admin", admin_logout: "Esci",
    admin_businesses: "Attività", admin_inquiries: "Richieste", admin_content: "Contenuti",
    no_content_yet: "I contenuti sono in preparazione. Torna tra un momento.",
    read_more: "Leggi di più",
  },
  ru: {
    nav_home: "Главная", nav_history: "История", nav_sights: "Достопримечательности", nav_beaches: "Пляжи и дайвинг",
    nav_mountains: "Горы и пустыня", nav_directory: "Каталог", nav_tips: "Советы",
    nav_gallery: "Галерея", nav_map: "Карта", nav_advertise: "Реклама", nav_admin: "Админ",
    hero_eyebrow: "Красное море · Египет",
    hero_title: "Эль-Кусейр",
    hero_subtitle: "Древний порт. Вечный берег. Живая мозаика культур, течений и веков на египетском побережье Красного моря.",
    hero_cta_primary: "Открыть город", hero_cta_secondary: "Найти отель",
    section_history: "История", section_sights: "Достопримечательности", section_beaches: "Пляжи",
    section_diving: "Дайвинг", section_mountains: "Горы и пустыня", section_culture: "Культура", section_tips: "Советы",
    dive_sites_title: "Знаменитые места для дайвинга",
    home_eyebrow_welcome: "01 — Добро пожаловать",
    home_eyebrow_discover: "02 — Откройте для себя",
    home_intro_heading: "Там, где пустыня встречается с рифом.",
    home_discover_heading: "Четыре причины полюбить Эль-Кусейр.",
    home_history_blurb: "От фараоновских экспедиций в Пунт до османской крепости 1571 года.",
    home_beaches_blurb: "Тихие бухты, золотой песок, прозрачная вода.",
    home_diving_blurb: "Нетронутые рифы, дельфины Сатайи, отвесные стены Эльфинстоуна.",
    home_sights_blurb: "Дома из кораллового камня, крепостные стены, закат над гаванью.",
    home_for_business: "Для местного бизнеса",
    directory_title: "Где остановиться, поесть и отдохнуть",
    directory_subtitle: "Избранные отели, рестораны, дайвинг-центры и магазины в Эль-Кусейре.",
    tab_all: "Все", tab_hotel: "Отели", tab_restaurant: "Рестораны", tab_diving: "Дайвинг", tab_shop: "Магазины", tab_activity: "Активности",
    featured: "Рекомендовано", sponsored: "Реклама",
    advertise_title: "Продвигайте свой бизнес",
    advertise_subtitle: "Привлекайте путешественников со всего мира. Разместите ваш отель, ресторан или магазин на туристическом портале Эль-Кусейра.",
    form_name: "Ваше имя", form_email: "E-mail", form_business: "Название компании",
    form_business_type: "Тип бизнеса", form_message: "Сообщение", form_submit: "Отправить",
    form_success: "Спасибо, мы свяжемся с вами в ближайшее время.",
    map_title: "Найти Эль-Кусейр",
    footer_about: "Эль-Кусейр — исторический портовый город на Красном море в Восточной пустыне Египта.",
    footer_rights: "Все права защищены.",
    admin_login_title: "Вход для администратора",
    admin_email: "E-mail", admin_password: "Пароль", admin_signin: "Войти",
    admin_dashboard: "Панель администратора", admin_logout: "Выйти",
    admin_businesses: "Заведения", admin_inquiries: "Запросы", admin_content: "Контент",
    no_content_yet: "Контент готовится. Пожалуйста, зайдите чуть позже.",
    read_more: "Читать далее",
  },
  ar: {
    nav_home: "الرئيسية", nav_history: "التاريخ", nav_sights: "المعالم", nav_beaches: "الشواطئ والغوص",
    nav_mountains: "الجبال والصحراء", nav_directory: "الدليل", nav_tips: "نصائح السفر",
    nav_gallery: "الصور", nav_map: "الخريطة", nav_advertise: "إعلن معنا", nav_admin: "الإدارة",
    hero_eyebrow: "البحر الأحمر · مصر",
    hero_title: "القُصير",
    hero_subtitle: "ميناء عريق وساحل خالد، ولوحة حيّة من الثقافات والتيارات والقرون على البحر الأحمر المصري.",
    hero_cta_primary: "استكشف المدينة", hero_cta_secondary: "ابحث عن فندق",
    section_history: "التاريخ", section_sights: "المعالم", section_beaches: "الشواطئ",
    section_diving: "الغوص", section_mountains: "الجبال والصحراء", section_culture: "الثقافة", section_tips: "نصائح السفر",
    dive_sites_title: "أشهر مواقع الغوص",
    home_eyebrow_welcome: "01 — أهلاً وسهلاً",
    home_eyebrow_discover: "02 — اكتشف",
    home_intro_heading: "حيث تلتقي الصحراء بالشعاب المرجانية.",
    home_discover_heading: "أربع طرق لتقع في حب القصير.",
    home_history_blurb: "من بعثات بونت الفرعونية إلى القلعة العثمانية عام 1571.",
    home_beaches_blurb: "خلجان هادئة، رمال ذهبية، مياه صافية.",
    home_diving_blurb: "شعاب بكر، دلافين ساتايا، جدران إلفينستون.",
    home_sights_blurb: "بيوت الحجر المرجاني، أسوار القلعة، غروب الشمس على الميناء.",
    home_for_business: "للأعمال المحلية",
    directory_title: "أين تقيم وتأكل وتستكشف",
    directory_subtitle: "فنادق ومطاعم ومراكز غوص ومتاجر مختارة في القصير.",
    tab_all: "الكل", tab_hotel: "الفنادق", tab_restaurant: "المطاعم", tab_diving: "الغوص", tab_shop: "المتاجر", tab_activity: "أنشطة",
    featured: "مميز", sponsored: "إعلان",
    advertise_title: "روّج لعملك",
    advertise_subtitle: "اصل إلى مسافرين من جميع أنحاء العالم. أدرج فندقك أو مطعمك أو متجرك في بوابة القصير السياحية.",
    form_name: "الاسم", form_email: "البريد الإلكتروني", form_business: "اسم النشاط",
    form_business_type: "نوع النشاط", form_message: "الرسالة", form_submit: "إرسال",
    form_success: "شكراً لك، سنتواصل معك قريباً.",
    map_title: "موقع القصير",
    footer_about: "القصير مدينة ميناء تاريخية على البحر الأحمر في الصحراء الشرقية المصرية.",
    footer_rights: "جميع الحقوق محفوظة.",
    admin_login_title: "دخول المسؤول",
    admin_email: "البريد", admin_password: "كلمة المرور", admin_signin: "دخول",
    admin_dashboard: "لوحة التحكم", admin_logout: "خروج",
    admin_businesses: "الأعمال", admin_inquiries: "الاستفسارات", admin_content: "المحتوى",
    no_content_yet: "يتم تجهيز المحتوى. الرجاء العودة بعد قليل.",
    read_more: "اقرأ المزيد",
  },
  zh: {
    nav_home: "首页", nav_history: "历史", nav_sights: "景点", nav_beaches: "海滩与潜水",
    nav_mountains: "山脉与沙漠", nav_directory: "指南", nav_tips: "旅行贴士",
    nav_gallery: "相册", nav_map: "地图", nav_advertise: "广告", nav_admin: "管理",
    hero_eyebrow: "红海 · 埃及",
    hero_title: "库赛尔",
    hero_subtitle: "古老的港口,永恒的海岸。埃及红海边一幅由文化、洋流与千年交织而成的鲜活画卷。",
    hero_cta_primary: "探索小镇", hero_cta_secondary: "寻找酒店",
    section_history: "历史", section_sights: "景点", section_beaches: "海滩",
    section_diving: "潜水", section_mountains: "山脉与沙漠", section_culture: "文化", section_tips: "旅行贴士",
    dive_sites_title: "标志性潜水点",
    home_eyebrow_welcome: "01 — 欢迎",
    home_eyebrow_discover: "02 — 探索",
    home_intro_heading: "沙漠与珊瑚礁相遇之地。",
    home_discover_heading: "爱上库赛尔的四种方式。",
    home_history_blurb: "从法老时代的蓬特远征到 1571 年的奥斯曼堡垒。",
    home_beaches_blurb: "静谧的海湾、金色的沙滩、清澈的海水。",
    home_diving_blurb: "原始珊瑚礁、萨塔亚海豚、埃尔芬斯通陡壁。",
    home_sights_blurb: "珊瑚石房屋、堡垒城墙、港口日落。",
    home_for_business: "面向本地商家",
    directory_title: "住宿、餐饮与游玩",
    directory_subtitle: "精选库赛尔的酒店、餐厅、潜水中心和商店。",
    tab_all: "全部", tab_hotel: "酒店", tab_restaurant: "餐厅", tab_diving: "潜水", tab_shop: "商店", tab_activity: "活动",
    featured: "推荐", sponsored: "赞助",
    advertise_title: "推广您的业务",
    advertise_subtitle: "吸引来自全球的游客。在库赛尔旅游门户上展示您的酒店、餐厅或商店。",
    form_name: "您的姓名", form_email: "电子邮箱", form_business: "公司名称",
    form_business_type: "业务类型", form_message: "留言", form_submit: "发送",
    form_success: "感谢您,我们会尽快联系您。",
    map_title: "查找库赛尔",
    footer_about: "库赛尔是埃及东部沙漠中一座历史悠久的红海港口城市。",
    footer_rights: "版权所有。",
    admin_login_title: "管理员登录",
    admin_email: "邮箱", admin_password: "密码", admin_signin: "登录",
    admin_dashboard: "管理面板", admin_logout: "退出",
    admin_businesses: "商户", admin_inquiries: "咨询", admin_content: "内容",
    no_content_yet: "内容正在准备中,请稍后再来。",
    read_more: "阅读更多",
  },
  ja: {
    nav_home: "ホーム", nav_history: "歴史", nav_sights: "見どころ", nav_beaches: "ビーチ・ダイビング",
    nav_mountains: "山と砂漠", nav_directory: "ガイド", nav_tips: "旅のヒント",
    nav_gallery: "ギャラリー", nav_map: "地図", nav_advertise: "広告", nav_admin: "管理",
    hero_eyebrow: "紅海 · エジプト",
    hero_title: "アル・クセイル",
    hero_subtitle: "古代の港、永遠の海岸。エジプト紅海沿岸に息づく、文化と海流と千年の歴史のモザイク。",
    hero_cta_primary: "街を探索", hero_cta_secondary: "ホテルを探す",
    section_history: "歴史", section_sights: "見どころ", section_beaches: "ビーチ",
    section_diving: "ダイビング", section_mountains: "山と砂漠", section_culture: "文化", section_tips: "旅のヒント",
    dive_sites_title: "象徴的なダイビングサイト",
    home_eyebrow_welcome: "01 — ようこそ",
    home_eyebrow_discover: "02 — 発見",
    home_intro_heading: "砂漠とサンゴ礁が出会う場所。",
    home_discover_heading: "アル・クセイルに恋する4つの理由。",
    home_history_blurb: "ファラオのプント遠征から1571年のオスマン要塞まで。",
    home_beaches_blurb: "静かな入江、黄金の砂、透き通った海。",
    home_diving_blurb: "手つかずのサンゴ礁、サタヤのイルカ、エルフィンストーンの断崖。",
    home_sights_blurb: "サンゴ石の家々、要塞の壁、港の夕日。",
    home_for_business: "地元のビジネスへ",
    directory_title: "宿泊・食事・体験",
    directory_subtitle: "アル・クセイルの厳選されたホテル、レストラン、ダイビングセンター、ショップ。",
    tab_all: "すべて", tab_hotel: "ホテル", tab_restaurant: "レストラン", tab_diving: "ダイビング", tab_shop: "ショップ", tab_activity: "アクティビティ",
    featured: "おすすめ", sponsored: "広告",
    advertise_title: "あなたのビジネスを宣伝",
    advertise_subtitle: "世界中の旅行者にアプローチ。アル・クセイル観光ポータルにホテル、レストラン、ショップを掲載しましょう。",
    form_name: "お名前", form_email: "メール", form_business: "ビジネス名",
    form_business_type: "ビジネスの種類", form_message: "メッセージ", form_submit: "送信",
    form_success: "ありがとうございます。まもなくご連絡いたします。",
    map_title: "アル・クセイルを見つける",
    footer_about: "アル・クセイルはエジプト東部砂漠にある紅海の歴史的な港町です。",
    footer_rights: "無断転載を禁じます。",
    admin_login_title: "管理者ログイン",
    admin_email: "メール", admin_password: "パスワード", admin_signin: "ログイン",
    admin_dashboard: "管理ダッシュボード", admin_logout: "ログアウト",
    admin_businesses: "ビジネス", admin_inquiries: "お問い合わせ", admin_content: "コンテンツ",
    no_content_yet: "コンテンツを準備中です。しばらくしてからお越しください。",
    read_more: "続きを読む",
  },
  da: {
    nav_home: "Forside", nav_history: "Historie", nav_sights: "Seværdigheder", nav_beaches: "Strande & Dykning",
    nav_mountains: "Bjerge & Ørken", nav_directory: "Oversigt", nav_tips: "Rejsetips",
    nav_gallery: "Galleri", nav_map: "Kort", nav_advertise: "Annoncér", nav_admin: "Admin",
    hero_eyebrow: "Rødehavet · Egypten",
    hero_title: "Al Quseir",
    hero_subtitle: "En ældgammel havn. En tidløs kyst. En levende mosaik af kulturer, strømninger og århundreder ved det egyptiske Rødehav.",
    hero_cta_primary: "Udforsk byen", hero_cta_secondary: "Find et hotel",
    section_history: "Historie", section_sights: "Seværdigheder", section_beaches: "Strande",
    section_diving: "Dykning", section_mountains: "Bjerge & Ørken", section_culture: "Kultur", section_tips: "Rejsetips",
    dive_sites_title: "Ikoniske dykkersteder",
    home_eyebrow_welcome: "01 — Velkommen",
    home_eyebrow_discover: "02 — Oplev",
    home_intro_heading: "Hvor ørkenen møder revet.",
    home_discover_heading: "Fire måder at blive forelsket i Al Quseir.",
    home_history_blurb: "Fra faraoernes Punt-ekspeditioner til den osmanniske fæstning fra 1571.",
    home_beaches_blurb: "Stille bugter, gyldent sand, krystalklart vand.",
    home_diving_blurb: "Urørte rev, delfinerne ved Sataya, Elphinstones lodrette vægge.",
    home_sights_blurb: "Korallsten-huse, fæstningsmure, solnedgang over havnen.",
    home_for_business: "Til lokale virksomheder",
    directory_title: "Hvor du kan bo, spise og opleve",
    directory_subtitle: "Udvalgte hoteller, restauranter, dykkercentre og butikker i Al Quseir.",
    tab_all: "Alle", tab_hotel: "Hoteller", tab_restaurant: "Restauranter", tab_diving: "Dykning", tab_shop: "Butikker", tab_activity: "Aktiviteter",
    featured: "Fremhævet", sponsored: "Sponsoreret",
    advertise_title: "Markedsfør din virksomhed",
    advertise_subtitle: "Nå rejsende fra hele verden. Opret dit hotel, din restaurant eller butik på Al Quseirs turistportal.",
    form_name: "Dit navn", form_email: "E-mail", form_business: "Virksomhedsnavn",
    form_business_type: "Virksomhedstype", form_message: "Besked", form_submit: "Send forespørgsel",
    form_success: "Tak, vi kontakter dig snart.",
    map_title: "Find Al Quseir",
    footer_about: "Al Quseir er en historisk havneby ved Rødehavet i Egyptens østlige ørken.",
    footer_rights: "Alle rettigheder forbeholdes.",
    admin_login_title: "Admin log-in",
    admin_email: "E-mail", admin_password: "Adgangskode", admin_signin: "Log ind",
    admin_dashboard: "Admin dashboard", admin_logout: "Log ud",
    admin_businesses: "Virksomheder", admin_inquiries: "Forespørgsler", admin_content: "Indhold",
    no_content_yet: "Indholdet er under udarbejdelse. Kom tilbage om et øjeblik.",
    read_more: "Læs mere",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("aq_lang") || "en");
  const [content, setContent] = useState({});

  const isRTL = lang === "ar";

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("aq_lang", l);
  };

  useEffect(() => {
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang, isRTL]);

  const fetchContent = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/content/${lang}`);
      setContent(res.data || {});
    } catch (e) {
      console.error("content fetch", e);
      setContent({});
    }
  }, [lang]);

  useEffect(() => { fetchContent(); }, [fetchContent]);

  const t = (key) => (STATIC_T[lang] && STATIC_T[lang][key]) || STATIC_T.en[key] || key;

  return (
    <I18nContext.Provider value={{ lang, setLang, isRTL, t, content, refreshContent: fetchContent }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
